import { render, staticRenderFns } from "./SelectPeopleComboBox.vue?vue&type=template&id=e717c260&scoped=true"
import script from "./SelectPeopleComboBox.vue?vue&type=script&lang=js"
export * from "./SelectPeopleComboBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e717c260",
  null
  
)

export default component.exports